import { createIcon } from '@chakra-ui/react';

export const StarOutline = createIcon({
  displayName: 'StarOutline',
  viewBox: '0 0 20 19.161',
  path: (
    <g id="Star_-_L" data-name="Star - L" transform="translate(0 0)">
      <path
        id="Star_-_L-2"
        data-name="Star - L"
        d="M20.457,9.057a1.168,1.168,0,0,0-1.127-.816H13.44L11.63,2.659h0a1.165,1.165,0,0,0-1.114-.819h0a1.162,1.162,0,0,0-1.127.826L7.6,8.285,1.708,8.241h0a1.184,1.184,0,0,0-.689,2.149l4.8,3.448L3.947,19.4a1.184,1.184,0,0,0,1.807,1.334l4.731-3.454,4.763,3.493a1.184,1.184,0,0,0,1.826-1.321l-1.794-5.613,4.763-3.458A1.165,1.165,0,0,0,20.457,9.057Zm-.987.559L14.44,13.273a.476.476,0,0,0-.171.53l1.905,5.928a.238.238,0,0,1-.356.257l-5.042-3.674a.483.483,0,0,0-.279-.092.476.476,0,0,0-.279.092l-5.01,3.674a.238.238,0,0,1-.365-.27l1.984-5.9a.467.467,0,0,0-.175-.533L1.562,9.628a.235.235,0,0,1-.089-.27A.232.232,0,0,1,1.7,9.193h0l6.226.041h0a.473.473,0,0,0,.451-.318l1.905-5.953a.232.232,0,0,1,.232-.181h0a.232.232,0,0,1,.225.165l1.905,5.925a.47.47,0,0,0,.451.318h0l6.233,0a.222.222,0,0,1,.229.165A.229.229,0,0,1,19.469,9.615Z"
        transform="translate(-0.521 -1.84)"
        fill="#135cb0"
      />
    </g>
  ),
});

export const StarFilled = createIcon({
  displayName: 'StarFilled',
  viewBox: '0 0 20 19.107',
  path: (
    <g
      id="Star_Filled_-_L"
      data-name="Star Filled - L"
      transform="translate(0 0)"
    >
      <path
        id="Star_Filled_-_L-2"
        data-name="Star Filled - L"
        d="M20.456,9.035a1.162,1.162,0,0,0-1.127-.814H13.44L11.63,2.657h0a1.165,1.165,0,0,0-1.114-.817h0a1.162,1.162,0,0,0-1.127.823L7.6,8.266,1.708,8.222h0a1.18,1.18,0,0,0-.689,2.143l4.8,3.438-1.87,5.546a1.183,1.183,0,0,0,1.807,1.33l4.731-3.444,4.762,3.482a1.171,1.171,0,0,0,.7.231,1.193,1.193,0,0,0,.7-.228,1.166,1.166,0,0,0,.432-1.32l-1.794-5.6,4.762-3.447a1.157,1.157,0,0,0,.416-1.32Z"
        transform="translate(-0.521 -1.84)"
        fill="#135cb0"
      />
    </g>
  ),
});

export const StarWIthOutlineBg = createIcon({
  displayName: 'StarWIthOutlineBg',
  viewBox: '0 0 20 20',
  path: (
    <g
      id="Group_3003"
      data-name="Group 3003"
      transform="translate(-286.986 -12)"
    >
      <g
        id="Rectangle_504"
        data-name="Rectangle 504"
        transform="translate(286.986 12)"
        fill="#135cb0"
        stroke="#135cb0"
        strokeWidth="1"
      >
        <rect width="20" height="20" rx="10" stroke="none" />
        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="none" />
      </g>
      <g
        id="Star_Filled"
        data-name="Star Filled"
        transform="translate(290.986 16)"
      >
        <rect id="bg" width="12" height="12" fill="none" />
        <path
          id="Star_Filled_-_S"
          data-name="Star Filled - S"
          d="M12.477,5.052a1,1,0,0,0-.952-.744H8.418L7.466,1.42h0a1.007,1.007,0,0,0-.952-.7h0a1.007,1.007,0,0,0-.963.7L4.6,4.385H1.515A1.007,1.007,0,0,0,.924,6.19L3.451,8.006l-.985,2.921A1.007,1.007,0,0,0,4.02,12.021l2.494-1.772,2.494,1.827a1.007,1.007,0,0,0,1.193,0,1.017,1.017,0,0,0,.372-1.094L9.611,8.006l2.505-1.827a1,1,0,0,0,.361-1.127Z"
          transform="translate(-0.53 -0.496)"
          fill="#fff"
        />
      </g>
    </g>
  ),
});
